module.exports = __webpack_public_path__ + "img/404.2a9389f3.png";